var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Name',{style:(_vm.nameStyle)}),_c('Skills',{staticClass:"compItem"}),_c('Experience',{staticClass:"compItem"}),_c('ProjectsGrid',{staticClass:"compItem"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }